import React from "react";
import { useAppSelector } from "../../hooks/redux";
import { selectWorklistGroup } from "../../selectors/store";
import { useTheme } from "@mui/material";
import { map } from "lodash";
import { FullScreenHandle } from "react-full-screen";
import { WorklistGroupOrder } from "./WorklistGroupOrder";
import FlexView from "react-flexview";
import { KDSOffline } from "../Offline";

interface Props {
  handleFullscreen: FullScreenHandle;
}

export const WorklistGroupOrders: React.FC<Props> = ({ handleFullscreen }) => {
  const group = useAppSelector(selectWorklistGroup);
  const theme = useTheme();

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: theme.palette.background.default,
      }}
    >
      <KDSOffline />
      <FlexView style={{ flex: 1 }}>
        {map(group?.worklists, (_, worklistId) => (
          <WorklistGroupOrder
            key={worklistId}
            worklistId={worklistId}
            handleFullscreen={handleFullscreen}
          />
        ))}
      </FlexView>
    </div>
  );
};
